import { HeadFC, PageProps, graphql } from "gatsby";
import React, { FC } from "react";
import SEO from "../components/Seo";
import Layout from "../components/Layout";
import Autocomplete from "../components/Autocomplete";
import BreadCrumb from "../components/BreadCrumb";
import { ArtistPageContext } from "../../gatsby-node";
import styled from "styled-components";
import Adsense from "../components/Adsense";

const AdsenseContainer = styled.div`
  height: 320px;
`;

interface Props {
  site: Queries.Site;
  allChordsJson: {
    edges: {
      node: Queries.ChordsJson;
    }[];
  };
}

const Artist: FC<PageProps<Props, ArtistPageContext>> = ({
  data: {
    site: { siteMetadata },
    allChordsJson: { edges },
  },
  location: { pathname },
  pageContext: { artist },
}) => {
  return (
    <Layout>
      <BreadCrumb
        items={[
          {
            name: "トップ",
            // url: (siteMetadata?.siteUrl ?? "") + "/",
            url: "/",
          },
        ]}
      />
      <AdsenseContainer>
        <Adsense path={pathname} />
      </AdsenseContainer>
      <h2>{artist} のコード進行一覧</h2>
      <Autocomplete songs={edges} />
    </Layout>
  );
};

export const query = graphql`
  query Song($artist: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    allChordsJson(
      filter: { artists: { in: [$artist] } }
      sort: { addedDate: DESC }
    ) {
      edges {
        node {
          slug
          title
          subtitle
          artists
          youtubeVideoId
          addedDate
        }
      }
    }
  }
`;

export default Artist;

export const Head: HeadFC<Props, ArtistPageContext> = ({
  data: {
    site: { siteMetadata },
  },
  location: { pathname },
  pageContext: { artist },
}) => {
  const siteUrl = siteMetadata?.siteUrl;
  return (
    <SEO
      title={`${artist}のコード一覧 | ${siteMetadata?.title}`}
      description={`${artist}のコード進行`}
      url={`${siteUrl}${pathname}`}
    />
  );
};
